// ════════════════════════════════════════════════════════════════════════════
//  Udisys Gestor Web  —  src/features/financeiro/services/renegociacoesService.ts
//
//  RENEGOCIAÇÃO de contas a receber. É NOVAÇÃO: a dívida antiga é extinta e
//  substituída por um título novo. O oposto da fatura, que só agrupa.
// ════════════════════════════════════════════════════════════════════════════

import { apiClient } from '@/lib/apiClient';
import type {
  ParcelaFaturavelDto,
  RenegociarRequest,
  RenegociacaoResumoDto,
  RenegociacaoDetalheDto,
  PaginadoResponse,
} from '../types';

const BASE = '/api/financeiro/renegociacoes';

export interface FiltroRenegociacoes {
  pagina?: number;
  tamanhoPagina?: number;
  busca?: string;
  clienteId?: number;
}

export const renegociacoesService = {
  /** Parcelas em aberto elegíveis (não faturadas, não renegociadas). */
  async getCandidatas(clienteId: number): Promise<ParcelaFaturavelDto[]> {
    const { data } = await apiClient.get<ParcelaFaturavelDto[]>(`${BASE}/candidatas`, {
      params: { clienteId },
    });
    return data;
  },

  async renegociar(req: RenegociarRequest): Promise<RenegociacaoDetalheDto> {
    const { data } = await apiClient.post<RenegociacaoDetalheDto>(BASE, req);
    return data;
  },

  async getAll(filtro: FiltroRenegociacoes = {}): Promise<PaginadoResponse<RenegociacaoResumoDto>> {
    const { data } = await apiClient.get<PaginadoResponse<RenegociacaoResumoDto>>(BASE, {
      params: {
        pagina:        filtro.pagina ?? 1,
        tamanhoPagina: filtro.tamanhoPagina ?? 20,
        busca:         filtro.busca && filtro.busca.trim() ? filtro.busca.trim() : undefined,
        clienteId:     filtro.clienteId || undefined,
      },
    });
    return data;
  },

  async getById(id: number): Promise<RenegociacaoDetalheDto> {
    const { data } = await apiClient.get<RenegociacaoDetalheDto>(`${BASE}/${id}`);
    return data;
  },

  /** Estorna: os títulos antigos voltam e o acordo é cancelado. */
  async estornar(id: number): Promise<void> {
    await apiClient.delete(`${BASE}/${id}`);
  },
};
